// Modelo Parameter para administrador.
export default class Parameter {
    id=""
    value=""
    name=""
    enabled=true
}



// WEBPACK FOOTER //
// ./src/model/Paramater.js